import React from 'react'
import Pdf from '../../pdf/Pdf'
function Q29() {
  return (
        <Pdf src={'18UDsmuGDixM1Ulw74JoVcyJTk4vGNXKC'} title={'تبوك بوابة القرن الحادي و العشرين pdf'} />
    
  )
}

export default Q29